import OtpInput from './OtpInput';

export default OtpInput;
